import { SingleSelectField } from "@dgs/core";
import { useFormikContext } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AssignableTravelSegmentType, TravelSegmentFormValues } from "../../../../../shared/types/travelSegment";
import { emptyCarFormValues } from "./TravelSegmentCarFormFields";
import { emptyFlightFormValues } from "./TravelSegmentFlightFormFields";
import { emptyTrainFormValues } from "./TravelSegmentTrainFormFields";

interface Props {
	name: string;
	label: string;
	availableTypes: AssignableTravelSegmentType[];
}

export const TravelSegmentTypeFormSelect: FC<Props> = ({ name, label, availableTypes }) => {
	const { t } = useTranslation();
	const formik = useFormikContext<TravelSegmentFormValues>();

	return (
		<SingleSelectField
			name={name}
			label={label}
			options={availableTypes}
			clearable={false}
			getLabel={(option) => t(option)}
			onChange={({ target: { value } }) => {
				switch (value) {
					case "car":
						void formik.setValues(emptyCarFormValues());
						break;
					case "flight":
						void formik.setValues(emptyFlightFormValues());
						break;
					case "train":
						void formik.setValues(emptyTrainFormValues());
						break;
				}
			}}
		/>
	);
};
